import {
  createMutationKeys,
  createQueryKeys,
  mergeQueryKeys,
} from '@lukemorales/query-key-factory'
import { APIAxiosInstance } from '@core/utils/api-axios-instance'
import { RequestTypes } from './requestTypes'
import { createQueryKeyString } from '@core/react-query/queryParams'

const viewQueryKeys = createQueryKeys('register-views', {
  byId: ({ templateId, viewId }: RequestTypes['getRegisterTemplateView']) => {
    return {
      queryKey: [templateId, viewId],
      queryFn: async () => {
        const { data } = await APIAxiosInstance.get(
          `registers/templates/${templateId}/views/${viewId}`,
          {},
        )
        return data
      },
    }
  },
  list: ({ templateId, ...rest }: RequestTypes['getRegisterTemplateViews']) => {
    const queryString = createQueryKeyString(rest)
    return {
      queryKey: [templateId, rest],
      queryFn: async () => {
        const { data } = await APIAxiosInstance.get(
          `registers/templates/${templateId}/views${queryString}`,
          {},
        )
        return data
      },
    }
  },
})

const viewMutationKeys = createMutationKeys('register-views', {
  createRegisterView: {
    mutationKey: null,
    mutationFn: async ({
      templateId,
      ...rest
    }: RequestTypes['createRegisterView']) => {
      const { data } = await APIAxiosInstance.post(
        `registers/templates/${templateId}/views`,
        { ...rest },
      )

      return data
    },
  },
  updateRegisterView: {
    mutationKey: null,
    mutationFn: async ({
      templateId,
      viewId,
      ...rest
    }: RequestTypes['updateRegisterView']) => {
      const { data } = await APIAxiosInstance.put(
        `registers/templates/${templateId}/views/${viewId}`,
        { ...rest },
      )

      return data
    },
  },
  updateRegisterViewProperties: {
    mutationKey: null,
    mutationFn: async ({
      templateId,
      viewId,
      ...rest
    }: RequestTypes['updateRegisterViewProperties']) => {
      const { data } = await APIAxiosInstance.put(
        `registers/templates/${templateId}/views/${viewId}/properties`,
        { ...rest },
      )

      return data
    },
  },
  deleteRegisterView: {
    mutationKey: null,
    mutationFn: async ({
      templateId,
      viewId,
    }: RequestTypes['deleteRegisterView']) => {
      const { data } = await APIAxiosInstance.delete(
        `registers/templates/${templateId}/views/${viewId}`,
        {},
      )

      return data
    },
  },
})

const registerViewsKeys = mergeQueryKeys(viewQueryKeys, viewMutationKeys)[
  'register-views'
]

export { registerViewsKeys }
